import {mapGetters} from "vuex";
// import Vue from "vue";
// import Rollbar from "rollbar/replay";

export default {
    computed: {
        ...mapGetters({ClientInfo: "StateClientInfo"}),
    },
    methods: {
      configureLoggingUser() {
        // Get user ID and username from the store
        const user_email = this.$store.getters.getUserEmail ?? null;
        const user_id = this.$store.getters.getUserId ?? null;
        if (!user_email || !user_id) return;

        // Build person payload
        const rollbarConfig = {
          payload: {
            person: {
              id: user_id,
              username: user_email
            }
          }
        };

        // // const shouldEnableReplay = !!this.$store.getters.userIsAdmin; // Only enable for admins
        // const shouldEnableReplay = true; // Enable for all logged-in users
        //
        // const currentOptions = Vue.prototype.$rollbar?.options;
        // const replayAlreadyEnabled = !!(currentOptions && currentOptions.replay && currentOptions.replay.enabled);
        //
        // let alterOptions = {};
        //
        // if (shouldEnableReplay && !replayAlreadyEnabled) {
        //   alterOptions = {
        //     replay: { enabled: true },
        //   };
        // }
        // else if (!shouldEnableReplay && replayAlreadyEnabled) {
        //   alterOptions = {
        //     replay: { enabled: false },
        //   };
        // }
        //
        // // preserve other existing options if available
        // const mergedOptions = Object.assign({}, currentOptions || {}, alterOptions);
        // // create a new Rollbar instance and attach to Vue prototype
        // Vue.prototype.$rollbar = new Rollbar(mergedOptions);

        // Apply person payload (works whether we recreated or not)
        this.$rollbar.configure(rollbarConfig);
      },
    }
};